import { Button, Progress, Tooltip } from "antd";
import { FullscreenOutlined, FullscreenExitOutlined } from "@ant-design/icons";
import get from "lodash/get";
export const cardObj = {
  title: "Connection Lost!",
  desciption: `It looks like your internet connection is unavailable. Please check
            your network settings and try again.`,
  btnText: "Got It",
};
export const POLLING_INTERVAL_MS = 2 * 60000;
export const themeClasses = {
  darkGray: {
    bgPrimary: "bg-gray-700",
    bgFullScreen: "bg-gray-700",
    textPrimary: "text-white",
    textSecondary: "text-white",
    cardBg: "bg-gray-600",
    cardBorder: "border-gray-900",
    cardShadow: "shadow-md",
    titleColor: "text-white",
    textColor: "text-white",
    mainBorder: "border-gray-900",
    sidebarBg: "bg-gray-600",
    sidebarBorder: "border-gray-900",
    chartBarColor: "#4F46E5",
  },
};

export const cardTitleBg = {
  1: "bg-green-700",
  2: "bg-red-700",
  3: "bg-orange-700",
};

export const cardTitleWidth ={
  1:150,
  2:140,
  3:140
}

export const getStatusTagColor = (status) => {
  switch (status) {
    case "ON":
      return "green";
    case "IDLE":
      return "gold";
    default:
      return "red";
  }
};

export const renderProgress = (value, themeClasses) => (
  <Progress
    type="circle"
    percent={value}
    size={60}
    strokeWidth={10}
    strokeColor={value > 90 ? "#52c41a" : value > 70 ? "#faad14" : "#ff7a45"}
    format={(percent) => (
      <span
        className={`text-xs font-semibold ${get(themeClasses, "textPrimary")}`}
      >
        {percent}
        <span className="ml-0.5">%</span>
      </span>
    )}
  />
);

export const Title = ({ text }) => {
  return (
    <h3 className="text-white font-bold">{text || "No template exists...!"}</h3>
  );
};
export const SubTitle = () => (
  <p className="text-white font-medium">
    Try refreshing page or connect with technical team.
  </p>
);
export const FullscreenButton = ({ isFullScreenMode, onToggle }) => (
  <Tooltip
    title={isFullScreenMode ? "Exit Fullscreen" : "Enter Fullscreen"}
    placement="leftTop"
    color="geekblue"
    getPopupContainer={(triggerNode) => triggerNode.parentNode || document.body}
  >
    <Button
      type="primary"
      size="large"
      onClick={onToggle}
      className={`fixed bottom-8 right-2 -translate-x-1/2 z-50
      !bg-blue-600 hover:!bg-blue-700 text-white font-semibold py-3 px-3 rounded-xl
      shadow-lg hover:shadow-xl transition-all duration-300 ease-in-out
      focus:outline-none focus:ring-4 focus:ring-blue-300 focus:ring-opacity-75
      transform hover:scale-105 ${isFullScreenMode ? "-ml-2 bottom-6" : ""}
      `}
      icon={
        isFullScreenMode ? <FullscreenExitOutlined /> : <FullscreenOutlined />
      }
    />
  </Tooltip>
);
